import Keycloak from 'keycloak-js';
import config from '../config';

class KeycloakService {
  constructor() {
    if (!KeycloakService.instance) {
      console.log('Initializing Keycloak with config:', config.keycloak); // Debug log
      this.keycloak = new Keycloak({
        url: config.keycloak.url,
        realm: config.keycloak.realm,
        clientId: config.keycloak.clientId
      });
      this.initialized = false;
      KeycloakService.instance = this;
    }
    return KeycloakService.instance;
  }

  async init() {
    if (this.initialized) {
      console.log('Keycloak already initialized'); // Debug log
      return this.keycloak.authenticated;
    }

    try {
      console.log('Initializing Keycloak...'); // Debug log
      const authenticated = await this.keycloak.init({
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
        pkceMethod: 'S256'
      });
      console.log('Keycloak initialized, authenticated:', authenticated); // Debug log
      this.initialized = true;
      return authenticated;
    } catch (error) {
      console.error('Keycloak init error:', error);
      throw error;
    }
  }

  login() {
    console.log('Initiating Keycloak login...'); // Debug log
    this.keycloak.login();
  }

  logout() {
    console.log('Initiating Keycloak logout...'); // Debug log
    this.keycloak.logout();
  }

  getToken() {
    const token = this.keycloak.token;
    console.log('Getting token:', token ? 'Token exists' : 'No token'); // Debug log
    return token;
  }

  isAuthenticated() {
    const isAuth = this.keycloak.authenticated;
    console.log('Checking authentication:', isAuth); // Debug log
    return isAuth;
  }

  updateToken(minValidity = 5) {
    console.log('Updating token...'); // Debug log
    return new Promise((resolve, reject) => {
      this.keycloak.updateToken(minValidity)
        .then(refreshed => {
          console.log('Token refreshed:', refreshed); // Debug log
          resolve(refreshed);
        })
        .catch(error => {
          console.error('Token refresh error:', error); // Debug log
          reject(error);
        });
    });
  }

  getUsername() {
    return this.keycloak.tokenParsed?.preferred_username;
  }

  hasRole(role) {
    if (!this.keycloak.authenticated) return false;
    
    // Check realm roles
    const realmRoles = this.keycloak.realmAccess?.roles || [];
    if (realmRoles.includes(role)) return true;
    
    // Check client roles
    const clientRoles = this.keycloak.tokenParsed?.resource_access?.[config.keycloak.clientId]?.roles || [];
    return clientRoles.includes(role);
  }

  getRoles() {
    if (!this.keycloak.authenticated) return [];
    
    const realmRoles = this.keycloak.realmAccess?.roles || [];
    const clientRoles = this.keycloak.tokenParsed?.resource_access?.[config.keycloak.clientId]?.roles || [];
    
    return [...new Set([...realmRoles, ...clientRoles])];
  }
}

// Create a singleton instance
const keycloakService = new KeycloakService();
export default keycloakService; 